import { StateSchema } from 'app/providers/StoreProvider';

export const getListOfSuppliers = (state: StateSchema) =>
    state.productSourcing?.listOfSuppliers;

export const getIsLoadingSuppliers = (state: StateSchema) =>
    state.productSourcing?.isLoadingSuppliers;

export const getIsSaveSettings = (state: StateSchema) =>
    state.productSourcing?.isSaveSettings;

export const getIsSaveSettingsToAllProperties = (state: StateSchema) =>
    state.productSourcing?.isSaveSettingsToAllProperties;

export const getListOfSourcingModes = (state: StateSchema) =>
    state.productSourcing?.listOfSourcingModes;

export const getIsLoadingSourcingModes = (state: StateSchema) =>
    state.productSourcing?.isLoadingSourcingModes;
